/* 
Author:Lamiaa Moustafa
Desc: Reusable Text component
*/

import React from "react";
import styled from "styled-components";



const TextS1st2911 = (props) => {
  const { text, className , customStyle} = props.data;
  return (
    <>
      <Paragraph style={customStyle} className={className}>{text}</Paragraph>
    </>
  );
};

 export default TextS1st2911;

 const Paragraph = styled.p`
 font-size: 18px;
 color: var(--darkGray);
`;


